
const UserDashboardChargerFilter = (chargersData, locationData, location, selectedDate, bookings) => {
    // console.log("charger daa in chargersData: ", chargersData)
    let bookingSlots = [];
    function getDateFromTimeString(timeString) {
        const [hours, minutes, seconds] = timeString.split(':');
        const [secs, millis] = seconds.split('.');
        const date = new Date();
        date.setHours(hours, minutes, secs, millis);
        return date;
    }

    function getTimeDifference(timeString) {
        let [time1, time2] = timeString.split("-")
        let date1 = getDateFromTimeString(time1)
        let date2 = getDateFromTimeString(time2)
        if (date2 < date1) {
            date2.setDate(date2.getDate() + 1);
        }
        const timeDifference = date2 - date1;
        return timeDifference // in millisec
    }


    // find time in charger timezone
    // attach to selected, prev and next day
    // check for applicable days 
    // if applicable convert into local timezone and attach to booked slots
    function getTimeZoneOffsetTwoTimezone(timeZone1, timeZone2, date = new Date()) {
        // Create a date object for both time zones
        const dateInTimeZone1 = new Date(date.toLocaleString('en-US', { timeZone: timeZone1 }));
        const dateInTimeZone2 = new Date(date.toLocaleString('en-US', { timeZone: timeZone2 }));
        // Get the difference in time in milliseconds
        const timeDifferenceInMilliseconds = dateInTimeZone2.getTime() - dateInTimeZone1.getTime();
        // Convert from milliseconds to hours
        // const timeDifferenceInHours = timeDifferenceInMilliseconds / (1000 * 60 * 60);
        return timeDifferenceInMilliseconds;
    }

    function findLimitingBookedSlots() {
        // console.log("locationData.sharedTime", locationData[0].sharedTime)
        let sharedTimes = locationData[0]?.sharedTime
        let newBookingSlots = []
        let daysToCheck = [new Date(new Date(selectedDate).setDate(new Date(selectedDate).getDate() - 1)), new Date(selectedDate), new Date(new Date(selectedDate).setDate(new Date(selectedDate).getDate() + 1))]
        // console.log(daysToCheck)

        daysToCheck.map((checkingDay) => {
            sharedTimes.map((timeRangeObject) => {
                // start time attach to slected day,(local time(setUTC))          #selected day - 1, selected day + 1
                // convet to charger time zone
                // check for applicable day
                // if applicable  
                // add offset to find end time 
                // change to local time zone 
                // create slot 

                let currentDay = new Date(checkingDay)
                // console.log("selected day: ", currentDay)
                let [startTime, endTime] = timeRangeObject.timeRange.split('-')
                let [hours, minutes, seconds] = startTime.split(':')
                const [secs, millis] = seconds.split('.');
                currentDay.setUTCHours(hours, minutes, secs, millis)
                let rangeEndTimeInLocal = new Date(currentDay.getTime() + getTimeDifference(timeRangeObject.timeRange))
                // console.log("rangeendtime in local: ", rangeEndTimeInLocal)
                // console.log("currentDay: ", currentDay)

                // if(selectedDate.getDate() !== currentDay.getDate()){
                //     if(selectedDate > currentDay){
                //         currentDay.setDate(currentDay.getDate()+1)
                //     }else if(selectedDate < currentDay){
                //         currentDay.setDate(currentDay.getDate()-1)
                //     }
                // }

                // currentDay.setUTCHours(hours)
                // currentDay.setUTCMinutes(minutes)
                // currentDay.setUTCSeconds(seconds)
                // console.log("start time attached selected day in local timezone: ", currentDay)

                // console.log("end time stamp in local timezone: ", rangeEndTimeInLocal)
                // if(currentDay>rangeEndTimeInLocal){
                //     console.log("range start in local is greater than range end in local")
                //     currentDay.setDate(currentDay.getDate()-1)
                // }
                const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
                // console.log(timeZone)
                let timeZoneOffSet = getTimeZoneOffsetTwoTimezone(localTimeZone, locationData[0]?.timezone, currentDay) // offset depends on order of timezones
                // console.log("offset of target time zone form local: ", )
                let startTimeInChargerTime = new Date((currentDay.getTime() + timeZoneOffSet))

                // console.log(startTimeInChargerTime.getDay())
                // console.log(startTimeInChargerTime)
                let endTimeInChargerTime = startTimeInChargerTime.getTime() + getTimeDifference(timeRangeObject.timeRange)
                // console.log("endTimeInChargerTime: ", new Date(endTimeInChargerTime))
                // let updatedEndTimeInLocalTimezone = new Date(endTimeInChargerTime - timeZoneOffSet)
                // let updatedstartTimeInLocalTimezone = new Date(startTimeInChargerTime.getTime()-timeZoneOffSet)
                // let newBookingSlot = 
                let updatedLocalStartTime = new Date(startTimeInChargerTime.getTime() - timeZoneOffSet)
                let updatedLocalEndTime = new Date(endTimeInChargerTime - timeZoneOffSet)
                // console.log("final date range in local : ")
                // console.log("updated start time in local timzone: ", updatedLocalStartTime)
                // console.log("updated end time in local timezone", updatedLocalEndTime)


                if (timeRangeObject.applicableDays[startTimeInChargerTime.getDay()] === 1) {
                    // console.log("time range is applicable in selected date")

                    // if( updatedLocalStartTime > rangeEndTimeInLocal){
                    //     console.log("inside local span condition: before setting start date", new Date(startTimeInChargerTime.getTime()-timeZoneOffSet))
                    //     console.log("range end time local timezone ", rangeEndTimeInLocal)
                    //     updatedLocalStartTime.setDate(updatedLocalStartTime.getDate()-1)
                    //     console.log("inside local span condition: after setting start date", updatedLocalStartTime)
                    // }

                    newBookingSlots.push({ end: updatedLocalEndTime, start: updatedLocalStartTime })
                    // console.log("updated slot time in local timezone , ", newBookingSlot)
                    // console.log(updatedstartTimeInLocalTimezone)
                    // console.log(updatedEndTimeInLocalTimezone)

                } else {
                    return
                }


            })
        })
        // setUpdatedBookedSlots(newBookingSlots)
        return newBookingSlots;
    }


    let chargingStations = [];
    let chargingStationsNonReservable = [];
    let chargingStationsNonReservableOffline = [];
    chargersData?.map((connector) => {


        bookingSlots = bookings?.filter(item => item.connector._id === connector._id).map(item => (
            { start: new Date(item.startTime), end: new Date(item.endTime) }));

        // add bookingSlots here

        // console.log("location ", location)
        // console.log("selected location: ", locationData)
        // console.log("data of booking slots", bookingSlots)
        // console.log("data of limiting slots", findLimitingBookedSlots())
        let isUsersLocation = location.some(item => item._id === locationData[0]?._id)
        // console.log("isUsersLocation", locationData)
        if (!isUsersLocation) {
            if (locationData[0]?.locationType === "SHARED-PUBLIC") {
                bookingSlots = bookingSlots?.concat(findLimitingBookedSlots())
            } else if (locationData[0]?.locationType === "SHARED-PRIVATE") {
                // console.log("giving acces to public users only in public times.")
                let availablePublicTimes = findLimitingBookedSlots()
                let unavailablePublicSlots = []
                availablePublicTimes.sort((a, b) => new Date(a.start) - new Date(b.start));
                console.log("availablePublicTimes: ", availablePublicTimes)
                availablePublicTimes.map((item, index) => {
                    let startTime;
                    let endTime;
                    if (index === 0) {
                        startTime = new Date(new Date(item.start).setHours(0, 0, 0, 0))
                    } else {
                        startTime = new Date(new Date(availablePublicTimes[index - 1].end).getTime() + 1)
                    }
                    endTime = new Date(new Date(item.start).getTime() - 1)
                    unavailablePublicSlots.push({ end: endTime, start: startTime })
                })
                if (availablePublicTimes.length > 0) {
                    unavailablePublicSlots.push({ end: new Date(new Date(new Date(availablePublicTimes[availablePublicTimes.length - 1].end).getTime() + 1).setHours(23, 59, 59, 999)), start: new Date(new Date(availablePublicTimes[availablePublicTimes.length - 1].end).getTime() + 1) })
                }
                // console.log(unavailablePublicSlots)
                bookingSlots = bookingSlots?.concat(unavailablePublicSlots)
                // current time to start - 1 ms 
                // end time+1ms to next start 
            }
            // "SHARED-PUBLIC"

            // location id not in user's location:
            //     public User:
            //         add booked slots with time range(private slots)

            // "SHARED-PRIVATE"

            // location id not in user's location:
            //     public user:
            //         add booked slots with time range except the 				shared time
        }

        // console.log("data of booking slots", bookingSlots)

        if (connector?.nonReservable) {
            if (connector?.chargerStatus === "Online") {
                chargingStationsNonReservable.push({
                    id: connector.charger._id,
                    bookedSlots: bookingSlots,
                    title: connector.charger.chargerTag,
                    connectorType: connector?.type, 
                    chargerStatus: connector?.chargerStatus,
                    power: connector?.power,
                    dynamicRates: connector.charger.dynamicRates,
                    status: connector?.status,
                    rateType: connector.charger.rateType,
                    normalRate: connector.charger.rate.price_components.price,
                    tax: connector.charger.rate.price_components.tax,
                    nonReservable: true,
                    rate: connector.charger.rate
                });
            }
            else {
                chargingStationsNonReservableOffline.push({
                    id: connector.charger._id,
                    bookedSlots: bookingSlots,
                    title: connector.charger.chargerTag,
                    connectorType: connector?.type,
                    chargerStatus: connector?.chargerStatus,
                    power: connector?.power,
                    dynamicRates: connector.charger.dynamicRates,
                    status: connector?.status,
                    rateType: connector.charger.rateType,
                    normalRate: connector.charger.rate.price_components.price,
                    tax: connector.charger.rate.price_components.tax,
                    nonReservable: true,
                    rate: connector.charger.rate
                });
            }

        }
        else {
            chargingStations.push({
                id: connector.charger._id,
                bookedSlots: bookingSlots,
                title: connector.charger.chargerTag,
                connectorType: connector?.type,
                chargerStatus: connector?.chargerStatus,
                power: connector?.power,
                dynamicRates: connector?.charger.dynamicRates,
                rateType: connector?.charger.rateType,
                normalRate: connector?.charger.rate.price_components.price,
                nonReservable: false,
                tax: connector?.charger.rate.price_components.tax
            });
        }

    });




    return {
        chargingStations,
        chargingStationsNonReservable,
        chargingStationsNonReservableOffline,
    };
};

export default UserDashboardChargerFilter;
